import React, { useEffect, useState, useContext } from "react";
import PageHeader from "../pageheader/PageHeader";
import MenuDoctor from "./navDoctor/MenuDoctor";
import { Option, Select } from "@material-tailwind/react";
import Input from "../material/input/Input";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import Pagination from "../pagination/Pagination";
import * as medicalApi from "../../service/medicalApi";
import { HashLoader } from "react-spinners";
import moment from "moment/moment";
import "moment/locale/th";
import { useNavigate } from "react-router";
import { RedirectCode400 } from "../RedirectCode400";

import { CurrentUserContext } from "../../App";

import styles from "./ListDataPatient.module.css";

import DialogTailwindConfirm from "../DialogTailwindConfirm";
import TableSearchV1 from "../tableV1/tableSearchV1";
import { FaTrashAlt, FaEdit, FaEye } from "react-icons/fa";

export default function StatusDataPatient() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [selectCheckSeeData, setSelectCheckSeeData] = useState([
    {
      id: "ACCEPT",
      name: "อนุญาตแล้ว",
    },
    {
      id: "PENDING",
      name: "ยังไม่ได้รับอนุญาต",
    },
    {
      id: "REJECT",
      name: "ปฏิเสธการเข้าถึงข้อมูล",
    },
    {
      id: "ALL",
      name: "สถานะทั้งหมด",
    },
  ]);

  const nav = useNavigate();

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [total, setTotal] = useState(null);
  const [filters, setFilters] = useState({});
  const [selectedData, setSelectedData] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [valueSearch, setValueSearch] = useState("");
  const [selectstatus, setSelectstatus] = useState("ALL");

  const [permission_list, setPermission_list] = useState([]);
  const [permission_list_storage, setPermission_list_storage] = useState([]);

  const presetTailwind = {
    DetailtablePosition: "w-full h-10 px-4 mt-3",
    DetailtableByPosition: "h-10 mt-3",
  };

  useEffect(() => {
    if (valueSearch !== "") {
      setPermission_list(
        permission_list.filter((element, idx) => {
          return element["patient"]["pid"].includes(valueSearch);
        }),
      );
    } else {
      setPermission_list(permission_list_storage);
    }
  }, [valueSearch]);

  useEffect(() => {
    getRequestPermission();
  }, [page, selectstatus]);

  const checkExpireToken = (expire, everyTime) => {
    if (everyTime === true) {
      return true;
    } else {
      let diff = moment().diff(expire, "seconds");
      // console.log(diff)
      if (diff >= 0) {
        return false;
      } else {
        return true;
      }
    }
  };

  //ใช้ default page ให้มาเริ่มต้นหลังเลือก option ใหม่
  useEffect(() => {
    setPage(1);
  }, [selectstatus]);

  const getRequestPermission = async () => {
    setLoading(true);
    let res = await medicalApi.getRequestPermission(selectstatus, page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setPermission_list(res["data"]["permission_list"]);
        setPermission_list_storage(res["data"]["permission_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
        setTotal(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const clickSearchPatietByPid = () => {
    if (valueSearch !== "") {
      setPermission_list(
        permission_list.filter((element, idx) => {
          return element["patient"]["pid"].includes(valueSearch);
        }),
      );
    } else {
      setPermission_list(permission_list_storage);
    }
  };

  const clickToComponentSearchDataPatient = (item) => {
    if (item["status"] === "ACCEPT") {
      if (
        checkExpireToken(
          item["credential_token_expire"],
          item["access_data_every_time"],
        )
      ) {
        nav("/doctor/permisstionLabPatient", {
          state: {
            credential_token: item["credential_token"],
          },
        });
      } else {
        setIsMessage({ type: "warning", data: "คำขอเข้าถึงข้อมูลหมดอายุ" });
      }
    } else if (item["status"] === "REJECT") {
      setIsMessage({
        type: "warning",
        data: `คุณ ${item["patient"]["fname"] + " " + item["patient"]["lname"]} ปฏิเสธการเข้าถึงข้อมูล`,
      });
    } else if (item["status"] === "PENDING") {
      setIsMessage({
        type: "warning",
        data: `คุณ ${item["patient"]["fname"] + " " + item["patient"]["lname"]} ยังไม่ได้รับอนุญาต`,
      });
    } else {
      setIsMessage({ type: "error", data: "ไม่สามารถดำเนินการได้" });
    }
  };
  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "credential_token",
      Cell: ({ row }) => {
        return (
          <div className="flex items-center justify-center hover:cursor-pointer">
            <div className="flex justify-center items-center">
              <button
                onClick={() => {
                  clickToComponentSearchDataPatient(row.original);
                }}
                className={`button-theme-pg p-0 text-sm 
                          flex justify-center items-center 
                          w-[140px] h-[30px] text-[#FFFFFF] 
                          rounded-3xl gap-1 
                          shadow-sm 
                        ${
                          row.original.status === "ACCEPT"
                            ? checkExpireToken(
                                row.original.credential_token_expire,
                                row.original.access_data_every_time,
                              )
                              ? "bg-[#64BD86] shadow-hard-green"
                              : "bg-[#BEBEBE] shadow-my-gray"
                            : row.original.status === "PENDING"
                              ? "bg-[#BEBEBE] shadow-my-gray"
                              : "bg-[#f94138] shadow-hard-red"
                        } `}
              >
                {row.original.status === "ACCEPT"
                  ? checkExpireToken(
                      row.original.credential_token_expire,
                      row.original.access_data_every_time,
                    )
                    ? "อนุญาตแล้ว"
                    : "ยังไม่ได้รับอนุญาต"
                  : row.original.status === "PENDING"
                    ? "ยังไม่ได้รับอนุญาต"
                    : "ปฏิเสธ"}
              </button>
            </div>
          </div>
        );
      },
    },
    {
      Header: "วันที่",
      accessor: "create_date.date",
      Filter: "date",
      wrap: false,
    },
    {
      Header: "เวลา",
      accessor: "create_date.time",
      wrap: false,
    },
    {
      Header: "ชื่อ-นามสกุล",
      accessor: "patient",
      Filter: "text",
      wrap: false,
      Cell: ({ row }) => {
        return (
          <div>
            {row.original.patient.pname +
              row.original.patient.fname +
              " " +
              row.original.patient.lname}
          </div>
        );
      },
    },
    {
      Header: "สถานะ",
      accessor: "status",
      Cell: ({ row }) => {
        return (
          <p
            className={`flex items-center text-[#000000] text-sm ${presetTailwind.DetailtablePosition}`}
          >
            {row.original.status === "ACCEPT"
              ? "อนุญาตแล้ว"
              : row.original.status === "PENDING"
                ? "ยังไม่ได้รับอนุญาต"
                : "ปฏิเสธการเข้าถึงข้อมูล"}
          </p>
        );
      },
      wrap: false,
    },
  ];

  return (
    <div className="items-center justify-center w-full">
      <div className="flex items-center justify-start lg:justify-center my-4">
        <div className="flex gap-4 w-8/12 lg:grid lg:grid-cols-1">
          <div className="w-2/6 lg:w-full">
            <Select
              label="เลือกสถานะการเข้าถึงข้อมูล"
              color={"orange"}
              value={selectstatus}
              onChange={setSelectstatus}
            >
              {selectCheckSeeData.map((i, idx) => {
                return (
                  <Option key={idx} value={i["id"]}>
                    {i["name"]}
                  </Option>
                );
              })}
            </Select>
          </div>

          <input
            disabledLabel
            className="lg:w-full border-2 border-solid border-[#A2B5BC] rounded-lg text-state-100 text-[#000000] px-4 placeholder-[#526F65]"
            // onChange={handleChangeInputSearch}
            placeholder="ค้นหาข้อมูลด้วยเลขบัตรประชาชน"
            value={valueSearch}
            onChange={(e) => {
              setValueSearch(e.target.value);
            }}
          ></input>
          <div className="flex justify-center items-center">
            <button
              onClick={clickSearchPatietByPid}
              className="button-theme-pg flex justify-center items-center w-28 h-9 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan "
            >
              <MagnifyingGlassIcon className="stroke-[#526F65] w-4" />
              <div className="text-sm text-[#000000]">ค้นหา</div>
            </button>
          </div>
        </div>
      </div>

      <TableSearchV1
        columns={columns}
        data={permission_list}
        filters={filters}
        setFilters={setFilters}
        total={total}
        page={page}
        maxPage={maxPage}
        setPage={setPage}
        noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
      />
    </div>
  );
}
